<template>
    <div class="size-selector">
        <a href="#"
           class="size btn-tool-setting"
           :class="classIsActive(config.reader.tool.sizes[index])"
           v-for="(item, index) in config.reader.tool.sizes"
           @click.prevent="setToolSize( config.reader.tool.sizes[index])"
        >
            <span class="dot"
                  :style="styleSize(item)"
            >
            </span>
        </a>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch}  from "vue"
    import {useTool} from "@/modules/reader/tools/tools";
    import config from "@/config/config.json";

    export default {
        setup(props, context) {

            const {
                toolState,
                TOOL_BRUSH,
                TOOL_HIGHLIGHTER,
                TOOL_NOTE,
                TOOL_ERASER,
                setToolSize,
            } = useTool();

            const styleColorBox = (item)=>{
                return {
                    background:item
                }
            }

            const styleSize = (item)=>{
                return {
                    width:`${item}px`,
                    height:`${item}px`,
                    borderRadius:`${item}px`
                }
            }

            const classIsActive = (size) => {
                if (toolState.activeTool === TOOL_BRUSH) {
                    return (size === toolState.brushSetting.size) ? "active" : "";
                } else if (toolState.activeTool ===  TOOL_HIGHLIGHTER) {
                    return (size === toolState.highlightSetting.size) ? "active" : "";
                } else if (toolState.activeTool ===  TOOL_ERASER) {
                    return (size === toolState.eraserSetting.size)? "active" : "";
                }
            }

            return {
                config,
                toolState,
                setToolSize,
                classIsActive,
                styleSize
            }
        }
    }

</script>

<style scoped lang="scss">

    .size-selector {
        display: flex;
        flex-wrap: wrap;
        padding:$tool-option-padding 0;
    }

    .size {
        width:38px;
        height:38px;
        margin:$tool-icon-margin;
        display:flex;
        align-items: center;
        justify-content: center;
    }

    .dot {
        background:#000;
    }


</style>